import React, { useState } from 'react';
import './PDPUnbox.scss';
import CTAButton from '../../UI/CTA/CTAButton/CTAButton';
import Owl from '../../UI/Graphics/Owl';
import { COLORS } from '../../../constants/colors';
import Loader from '../../UI/Icons/Loader/Loader';

const PDPUnbox = ({ heading, description, items, featuredImage, featuredProduct, addToCart }) => {
  const [fetching, setFetching] = useState(false);

  const addAction = async () => {
    const properties = {
      quantity: 1,
      id: featuredProduct.variants[0].id,
    };
    setFetching(true);
    await addToCart(properties, featuredProduct.heading)
      .then(() => setFetching(false))
      .catch(() => {
        setFetching(false);
        console.error('Error fetching, please try again');
      });
  };

  return (
    <div className="c-pdp-unbox">
      <div className="c-pdp-unbox__content">
        <div className="c-pdp-unbox__top">
          <div className="c-pdp-unbox__featured">
            <img
              src={featuredImage.url}
              alt={featuredImage.alt}
              className="c-pdp-unbox__featured-img"
            />
          </div>
          <div className="c-pdp-unbox__box">
            <h4 className="c-pdp-unbox__heading h2-roobert color-gray">{heading}</h4>
            <span className="c-pdp-unbox__items-desc body-2 color-gray">{description}</span>
            <ul className="c-pdp-unbox__items">
              {items.map((item) => (
                <li className="c-pdp-unbox__item eyebrow-1 color-gray">{item}</li>
              ))}
            </ul>
          </div>
        </div>

        {featuredProduct && (
          <div className="c-pdp-unbox__bottom">
            <div className="c-pdp-unbox__product-feature">
              <img
                src={featuredProduct.icon.url}
                alt={featuredProduct.icon.alt}
                className="c-pdp-unbox__product-feature-icon"
              />
              <h4 className="c-pdp-unbox__product-feature-heading h2-roobert color-black">
                {featuredProduct.heading}
              </h4>
              <p className="c-pdp-unbox__product-feature-desc body-1 color-black">
                {featuredProduct.description}
              </p>
              <CTAButton
                isButton={true}
                onClick={addAction}
                ariaLabel={`Add To Cart–${featuredProduct.price}`}
                type="secondary"
                text={
                  fetching ? <Loader lightMode={true} /> : `Add To Cart–${featuredProduct.price}`
                }
                additionalClasses="c-pdp-unbox__product-feature-cta cta color-black"
              />
              <Owl color={COLORS.gray2} />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
export default PDPUnbox;
